import {
  CalendarDays,
  Clock,
  Compass,
  House,
  type LucideIcon,
  ReceiptText,
  Trophy,
  Users,
} from "lucide-react";

export interface NavItem {
  label: string;
  icon: LucideIcon;
  href: string;
  /** Shown only to people with at least one active direct report (DECISIONS 2026-10-15). */
  managersOnly?: boolean;
  /** Shown only with the server switch EXPENSES_ENABLED on. */
  expensesOnly?: boolean;
  /**
   * A count pill: "ptoHr" = HR-routed PTO requests and cancel asks waiting on the HR approver;
   * "expenses" = claims waiting on this person.
   */
  badge?: "ptoHr" | "expenses";
}

/**
 * The left nav, in order. A page appears here only once it is built (spec: Home, Time,
 * Guidance, My Team, PTO, Expenses). Add a page = one entry here + its route in src/router.tsx.
 */
export const navItems: NavItem[] = [
  { label: "Home", icon: House, href: "/dashboard" },
  { label: "Time", icon: Clock, href: "/dashboard/time" },
  { label: "Guidance", icon: Compass, href: "/dashboard/guidance" },
  { label: "My Team", icon: Users, href: "/dashboard/team", managersOnly: true },
  { label: "PTO", icon: CalendarDays, href: "/dashboard/pto", badge: "ptoHr" },
  {
    label: "Expenses",
    icon: ReceiptText,
    href: "/dashboard/expenses",
    badge: "expenses",
    expensesOnly: true,
  },
  { label: "Incentives", icon: Trophy, href: "/dashboard/incentives" },
];

/** The nav for this person: manager-only pages need `managesAnyone`, Expenses its switch. */
export function visibleNavItems(
  items: NavItem[],
  managesAnyone: boolean,
  expensesEnabled = false,
): NavItem[] {
  return items.filter(
    (item) => (!item.managersOnly || managesAnyone) && (!item.expensesOnly || expensesEnabled),
  );
}
